// import { PubmedSearch } from 'external'
import { Subject } from 'rxjs';
import { Connection } from './connection';
import { ConnectorEditField, CEF } from './connector-edit-field';
import type { CoordinatorService } from './coordinator.service';
import { Databin } from './databin';

export type CONPAR = {
    tag: string;
    title: string;
    description: string;
    icon: string;

    isOnline?: boolean;
    searchFieldLs?: CEF[];
    resultFieldLs?: CEF[];
    plugin?: string;
    importType?: 'csv';
    importParams: any;
};
export class Connector {
    id;
    cls = 'connector';
    tag: string;
    title: string;
    description: string;
    icon: string;
    isOnline: boolean;

    private _databin?: Databin;
    private _currentConnection?: Connection;

    currentConnectionChange$ = new Subject<Connection>();
    // connectionLs: Connection[] = []

    connectionCounter = 0;

    d$;
    // filterTree

    hasFileImport = false;
    hasClipboardImport = false;
    hasSearch = true;

    importType: string | undefined;
    importParams: Object;

    plugin;

    searchEditFieldLs: ConnectorEditField[] = [];
    resultEditFieldLs: ConnectorEditField[] = [];

    constructor(
        public coords: CoordinatorService,
        params: CONPAR,
    ) {
        this.id = this.coords.uniqueId();
        this.d$ = this.coords.databin$;

        this.tag = params.tag;
        this.icon = `connector_${params.icon}`;
        this.title = params.title || this.tag.toUpperCase();
        this.description = params.description || '';
        this.isOnline = params.isOnline || false;

        this.importType = params.importType;
        this.importParams = params.importParams;

        this.d$.registerConnector(this);
        // this.filterTree = this.coords.filter$.createFilterTree(this.tag)

        const pl = this.coords.pluginMap.get(params.plugin || '');
        if (pl) this.plugin = pl;
    }

    clear() {
        // this.connectionLs = []
        this.connectionCounter = 0;
    }

    get databinConnectionLs() {
        return this._databin!.connectionLs.filter((c) => c.connector === this);
    }

    newConnection(databin: Databin) {
        this._databin = databin;
        this.connectionCounter++;
        // this.coords.databin$.parsedFileLs$.next(undefined)
        const c = new Connection(this.coords, { _connectorTag: this.tag });
        // this.connectionLs.push(c)
        return c;
    }

    deleteConnection(c: Connection) {
        // const i = this.connectionLs.indexOf(c)
        // console.log("DDD", this.connectionLs, i)
        // this.connectionLs.splice(i, 1)
        // if (this.currentConnection === c)
        //     this.currentConnection = this.connectionLs[0]
    }

    get currentConnection() {
        const ls = this.databinConnectionLs;

        if (!ls.length || !this._currentConnection) {
            if (ls.length) this._currentConnection = ls[0];
            else {
                const c = this.newConnection(this._databin!);
                this._currentConnection = c;
                // this._databin.addConnection(c)
            }
        }
        return this._currentConnection;
    }

    set currentConnection(val: Connection) {
        this._currentConnection = val;
        this.currentConnectionChange$.next(val);
    }

    editDialog(c: Connection, suffix = '') {
        this.coords.display$.dialog$.next({
            action: 'edit-connection',
            type: this.tag,
            connection: c,
        });
    }

    get connectionTitle() {
        let c = 1;
        let t;
        do {
            t = `${this.title} - ${c++}`;
        } while (!this.checkConnectionTitle(t));
        return t;
    }

    checkConnectionTitle(txt: string): boolean {
        txt = txt.trim();
        if (!txt) return false;
        // for (let c of this.connectionLs) {
        //     if (c === targetConnection)
        //         continue
        //     if (c.title.trim() == txt)
        //         return false
        // }
        return true;
    }

    get databin() {
        return this._databin;
    }
}
